import { useMemo } from "react";
import { lang, supportedLanguages } from "../i18n/config";

export default () => useMemo(() => {
    if (lang) {
        const savedLanguageFound = supportedLanguages.find(it => it.value === lang || lang.startsWith(it.value));
        if (savedLanguageFound) {
            return savedLanguageFound;
        }
    }
    return supportedLanguages[0];
}, []);